import { useState } from "react";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { CloseIcon } from "@gemini/icons";

import { useGlobalStore } from "../../utils/useGlobalStore/useGlobalStore";

const ErrorContent = ({ error }: { error: Error }) => {
  const { name, message, stack } = error;

  return (
    <Box>
      <Box
        as="h2"
        color="color.content.status.error.default"
      >
        {name}
      </Box>
      <Box marginBottom="spacing.16">{message}</Box>
      {stack && <Box>{stack}</Box>}
    </Box>
  );
};

export const ErrorOverlay = () => {
  const { errors } = useGlobalStore();
  const [isOpen, setIsOpen] = useState(Boolean(errors));

  if (!isOpen || !errors) return null;

  return (
    <Box
      position="fixed"
      zIndex="zIndex.4"
      left={0}
      top={0}
      right={0}
      bottom={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      backgroundColor="color.surface.constant.black.default"
      padding="spacing.32"
      opacity="opacity.90"
    >
      <Box
        position="absolute"
        left="1rem"
        top="1rem"
        width={"calc(100% - 2rem)"}
        height={"calc(100% - 2rem)"}
        backgroundColor="color.content.status.error.default"
        opacity="opacity.30"
      />
      <Box
        position="relative"
        width="100%"
        height="100%"
        overflowY="auto"
        padding="spacing.16"
        color="color.content.constant.white.default"
      >
        <Button
          position="absolute"
          top="spacing.8"
          right="spacing.8"
          variant="danger"
          icon={CloseIcon}
          onPress={() => setIsOpen(false)}
          iconOnly
          size="32"
        >
          Close
        </Button>
        {Object.entries(errors).map(([key, error]) => (
          <ErrorContent
            key={key}
            error={error}
          />
        ))}
      </Box>
    </Box>
  );
};
